<template>

	<div class="bios-section container-fluid" v-if="bioSection" :class="themeClass" js-bios-section>
		
		<header class="title-header" v-if="hasHeader">
			<div class="backdrop">
				<h2>
					<span class="subtitle" v-if="bioSection.eyebrow">{{ bioSection.eyebrow }}</span>
					<span class="title" v-if="bioSection.title">{{ bioSection.title }}</span>
				</h2>
			</div>
		</header>

		<div class="container">
			<section class="bios-section__featured" v-if="bioSection.bios">
				<div class="bios-section__featured-message" v-if="hasFeaturedMessage">
					<h3 class="title" v-if="bioSection.title">{{ bioSection.title }}</h3>
					<div class="description" v-if="bioSection.description" v-html="bioSection.description"></div>
					<a v-if="bioSection.readMoreLink && bioSection.readMoreLink.url" :href="bioSection.readMoreLink.url" class="cta-primary">
						<span v-if="bioSection.readMoreLink.text">{{ bioSection.readMoreLink.text }}</span>
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
					</a>
				</div>
				<Bio v-for="bio in featuredBios" :key="bio.id" :bio="bio"></Bio>
			</section>
			<section class="bios-section__grid" v-if="gridBios && gridBios.length > 0">
				<Bio v-for="bio in gridBios" :key="bio.id" :bio="bio"></Bio>
			</section>
		</div>
	</div>
	
</template>

<script>
	
	import Bio from './Bio.vue';
	
	export default {
		name: 'Bios',
		
		props: ['bioSection'],
		
		components: {
			Bio
		},
		
		computed: {
			themeClass() {
				if (this.bioSection && this.bioSection.theme && this.bioSection.theme.cssClass) {
					return this.bioSection.theme.cssClass;
				}
				return '';
			},
			
			hasHeader() {
				return this.bioSection && (this.bioSection.eyebrow || this.bioSection.title);
			},
			
			hasFeaturedMessage() {
				return this.bioSection && (this.bioSection.title || this.bioSection.description);
			},
			
			featuredBios() {
				if (!this.bioSection || !this.bioSection.bios) {
					return [];
				}
				return this.bioSection.bios.slice(0, 1);
			},
			
			gridBios() {
				if (!this.bioSection || !this.bioSection.bios) {
					return [];
				}
				return this.bioSection.bios.slice(1);
			}
		}
	}
	
</script>